/*
 * @Author: monai
 * @Date: 2021-05-11 17:22:37
 * @LastEditors: monai
 * @LastEditTime: 2022-02-14 15:32:14
 */
import { createApp } from 'vue';

export default (app: ReturnType<typeof createApp>, parameter: DevelopToolShare.InitParams)=>{
    app.mixin({
        computed: {
            MIXIN_LANG(){ return parameter.countryCode },
            MIXIN_TEXT(){ return parameter.reactiveText },
        }
    });
}